<template>
  <div>
    <file-uploader :compMode="compMode" entite="InvestmentOpportunity"></file-uploader>

    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-briefcase"></i>
        <span
          v-if="(compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY) && (projectType == 2)"
        >{{ $t('investmentOpportunity.property.create.title') }}</span>
        <span
          v-if="(compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY) && (projectType == 1)"
        >{{ $t('investmentOpportunity.innovation.create.title') }}</span>
        <span v-if="compMode == CRUDMODE.UPDATE">{{ $t('investmentOpportunity.edit.title') }}</span>
        <span v-if="compMode == CRUDMODE.READ">{{ $t('investmentOpportunity.view.title') }}</span>
        
        <toggle-button
        style="margin-left:20px"
          v-model="entity.displayInWebsite"
          :sync="true"
          :width="200"
          :height="30"
          :font-size="14"
          :labels="{checked: 'Affiché sur le site web', unchecked: 'Masqué sur le site web'}"
        />
      </div>
      <div class="card-body">
        <errorMessage v-bind:message="error"></errorMessage>
        <form @keyup.enter="createInvestmentOpportunity">
          <!-- 
            ################################
                Section entreprise
            ################################
          -->
          <div class="row">
            <div v-if="entity.creationTimeText != null" class="form-group col-md-2">
              <label>{{ $t('investmentOpportunity.form.created') }}</label>
              <strong class="form-control">{{ entity.creationTimeText }}</strong>
            </div>
            <div class="form-group col-md-2">
              <label for="stage">{{ $t('investmentOpportunity.form.stage') }}</label>
              <select
                v-model="entity.stage"
                disabled
                class="form-control"
                id="stage"
                :data-vv-as="$t('investmentOpportunity.form.stage')"
              >
                <option v-for="s in stages" :value="s.key" :key="s.key">{{s.value}}</option>
              </select>
            </div>
            <div class="form-group col-md-2">
              <label for="processStatus">{{ $t('investmentOpportunity.form.processStatus') }}</label>
              <select
                v-model="entity.processStatus"
                disabled
                class="form-control"
                id="processStatus"
                :data-vv-as="$t('investmentOpportunity.form.processStatus')"
              >
                <option v-for="s in processStatus" :value="s.key" :key="s.key">{{s.value}}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-2">
              <label for="idInput">{{ $t('investmentOpportunity.form.existingBusinessName') }}*</label>

              <input
                type="hidden"
                v-validate="{ required: this.entity.businessName == null && this.project_validated == null }"
                name="project_validated"
                v-model="project_validated"
              />

              <multiselect
                v-model="entity.project"
                id="ajax"
                open-direction="bottom"
                :options="projects"
                :multiple="false"
                :searchable="true"
                :loading="isLoading"
                :internal-search="false"
                :clear-on-select="true"
                :close-on-select="true"
                :options-limit="300"
                :max-height="600"
                :show-no-results="true"
                :hide-selected="true"
                :taggable="false"
                :custom-label="projectLabel"
                :placeholder="$t('project.investment.form.project')"
                :select-label="$t('multiselect.select-label')"
                @remove="onRemove"
                @search-change="asyncProjectsFind"
                @select="onSelect"
              >
                <span slot="noResult">{{ $t('multiselect.not-found')}}.</span>
              </multiselect>

              <span class="text-danger" v-if="errors.has('project')">{{ errors.first('project') }}</span>
              <span
                class="text-danger"
                v-if="errors.has('project_validated')"
              >{{ $t('validations.required') }}</span>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-1">Ou</div>
          </div>
          <div class="row">
            <div class="form-group col-md-2">
              <label for="idInput">{{ $t('investmentOpportunity.form.businessName') }}*</label>
              <input
                maxlength="250"
                v-model.trim="entity.businessName"
                name="businessName"
                type="text"
                class="form-control"
                id="businessName"
                :data-vv-as="$t('investmentOpportunity.form.businessName')"
                v-validate="{ required: this.project_validated == null && this.entity.businessName == null }"
              />
              <span
                class="text-danger"
                v-if="errors.has('businessName')"
              >{{ errors.first('businessName') }}</span>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">Entreprise</div>
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-2">
                      <label for="regionInput">{{ $t('investmentOpportunity.form.brandingName') }}</label>
                      <input
                        maxlength="250"
                        v-model.trim="entity.brandingName"
                        name="brandingName"
                        type="text"
                        class="form-control"
                        id="brandingName"
                        :data-vv-as="$t('investmentOpportunity.form.brandingName')"
                      />
                      <span
                        class="text-danger"
                        v-if="errors.has('brandingName')"
                      >{{ errors.first('brandingName') }}</span>
                    </div>

                    <div class="form-group col-md-2">
                      <label for="websiteUrl">{{ $t('investmentOpportunity.form.websiteUrl') }}</label>
                      <input
                        maxlength="250"
                        v-model.trim="entity.websiteUrl"
                        name="websiteUrl"
                        type="text"
                        class="form-control"
                        id="websiteUrl"
                      />
                    </div>

                    <div class="form-group col-md-2">
                      <label
                        for="businessCreationYear"
                      >{{ $t('investmentOpportunity.form.businessCreationYear') }}</label>
                      <input
                        maxlength="10"
                        v-model.trim="entity.businessCreationYear"
                        name="businessCreationYear"
                        type="number"
                        class="form-control"
                        id="businessCreationYear"
                        :data-vv-as="$t('investmentOpportunity.form.businessCreationYear')"
                      />
                      <span
                        class="text-danger"
                        v-if="errors.has('businessCreationYear')"
                      >{{ errors.first('businessCreationYear') }}</span>
                    </div>
                    <div class="form-group col-md-2">
                      <label
                        for="sector"
                      >{{ $t('investmentOpportunity.form.areaOfActivities') }}</label>
                        <input
                        type="hidden"
                        name="sector"
                        v-model="entity.sectorId"
                      />

                       <select
                        v-model="entity.sectorId"
                        class="form-control"
                        id="sector"
                        @change="sectorChange"
                      >
                        <option v-for="s in sectors" :value="s.id" :key="s.id">{{s.name.french}}</option>
                      </select>
                    </div>

                    <div class="form-group col-md-2" v-if="subSectors.length">
                      <label
                        for="sector"
                      >{{ $t('investmentOpportunity.form.subSector') }}</label>
                        <input
                        type="hidden"
                        name="subSector"
                        v-model="entity.subSectorId"
                      />

                       <select
                        v-model="entity.subSectorId"
                        class="form-control"
                        id="sector"
                      >
                        <option v-for="s in subSectors" :value="s.id" :key="s.id">{{s.name.french}}</option>
                      </select>
                    </div>

                    <div class="form-group col-md-2">
                      <label
                        for="impactInvestment"
                      >{{ $t('investmentOpportunity.form.impactInvestment') }}</label>
                        <input
                        class="custom-control-input"
                        type="checkbox"
                        name="impactInvestment"
                        v-model="entity.impactInvestment"
                      />

                        <label class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            name="impactInvestment"
                            class="custom-control-input"
                            id="impactInvestment"
                            v-model="entity.impactInvestment"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-label">Oui</span>
                        </label>

                    </div>
                  </div>
                   <div class="form-group">
                    <label
                      for="sectorPrecision"
                    >{{ $t('investmentOpportunity.form.sectorPrecision') }}</label>
                    <textarea
                      v-model.trim="entity.sectorPrecision"
                      name="sectorPrecision"
                      type="text"
                      class="form-control"
                      id="sectorPrecision"
                    ></textarea>
                  </div>
<div class="row">
                    <div class="form-group col-md-2">
                      <label
                        for="founderNumber"
                      >{{ $t('investmentOpportunity.form.founderNumber') }}</label>
                      <input
                        type="hidden"
                        :data-vv-as="$t('investmentOpportunity.form.founderNumber')"
                        name="founderNumber_validate"
                        v-model="entity.founderNumber"
                      />
                      <select
                        v-model="entity.founderNumber"
                        class="form-control"
                        id="founderNumber"
                        :data-vv-as="$t('investmentOpportunity.form.founderNumber')"
                      >
                        <option v-for="s in founderNumbers" :value="s.key" :key="s.key">{{s.value}}</option>
                      </select>
                      <span
                        class="text-danger"
                        v-show="errors.has('founderNumber_validate')"
                      >{{ errors.first('founderNumber_validate') }}</span>
                    </div>
                    <div class="form-group col-md-2">
                      <label
                        for="totalEmployeeCount"
                      >{{ $t('investmentOpportunity.form.fullTimeEmployeeCount') }}</label>
                      <input
                        maxlength="10"
                        v-model.trim="entity.totalEmployeeCount"
                        name="totalEmployeeCount"
                        type="number"
                        :data-vv-as="$t('investmentOpportunity.form.fullTimeEmployeeCount')"
                        class="form-control"
                        id="totalEmployeeCount"
                      />
                      <span
                        class="text-danger"
                        v-show="errors.has('totalEmployeeCount')"
                      >{{ errors.first('totalEmployeeCount') }}</span>
                    </div>

                    <div class="form-group col-md-2">
                      <label
                        for="partTimeEmployeeCount"
                      >{{ $t('investmentOpportunity.form.partTimeEmployeeCount') }}</label>
                      <input
                        maxlength="10"
                        v-model.trim="entity.partialTimeEmployeeCount"
                        name="partTimeEmployeeCount"
                        type="number"
                        :data-vv-as="$t('investmentOpportunity.form.partTimeEmployeeCount')"
                        class="form-control"
                        id="partTimeEmployeeCount"
                      />
                      <span
                        class="text-danger"
                        v-show="errors.has('partTimeEmployeeCount')"
                      >{{ errors.first('partTimeEmployeeCount') }}</span>
                    </div>

                    <div class="form-group col-md-2">
                      <label
                        for="selfEmployedEmployeeCount"
                      >{{ $t('investmentOpportunity.form.selfEmployedEmployeeCount') }}</label>
                      <input
                        maxlength="10"
                        v-model.trim="entity.selfEmployedEmployeeCount"
                        name="selfEmployedEmployeeCount"
                        type="number"
                        :data-vv-as="$t('investmentOpportunity.form.selfEmployedEmployeeCount')"
                        class="form-control"
                        id="selfEmployedEmployeeCount"
                      />
                      <span
                        class="text-danger"
                        v-show="errors.has('selfEmployedEmployeeCount')"
                      >{{ errors.first('selfEmployedEmployeeCount') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 
            ################################
                Section address
            ################################
          -->

          <address-component
            title="investmentOpportunity.form.headOfficeAddress"
            v-bind:address="entity.headOfficeAddress"
            :required="false"
          ></address-component>

          <!-- E
            ################################
                Section projet
            ################################
          -->

          <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">{{ $t('investmentOpportunity.form.project') }}</div>
                <div class="card-body">
                  <div class="row"  v-if="projectType == 2">
                    <div class="form-group col-md-6">
                    <label
                      for="projectDescription"
                    >{{ $t('investmentOpportunity.form.projectDescription') }} (FR)</label>
                    <textarea
                      v-model.trim="entity.projectDescription.french"
                      name="projectDescription"
                      type="text"
                      class="form-control"
                      :data-vv-as="$t('investmentOpportunity.form.projectDescription')"
                      id="projectDescription"
                    ></textarea>
                    <span
                      class="text-danger"
                      v-show="errors.has('projectDescription')"
                    >{{ errors.first('projectDescription') }}</span>
                  </div>
                    <div class="form-group col-md-6">
                    <label
                      for="projectDescription"
                    >{{ $t('investmentOpportunity.form.projectDescription') }} (EN)</label>
                    <textarea
                      v-model.trim="entity.projectDescription.english"
                      name="projectDescriptionEn"
                      type="text"
                      class="form-control"
                      :data-vv-as="$t('investmentOpportunity.form.projectDescription')"
                      id="projectDescriptionEn"
                    ></textarea>
                    <span
                      class="text-danger"
                      v-show="errors.has('projectDescriptionEn')"
                    >{{ errors.first('projectDescriptionEn') }}</span>
                  </div>
                  </div>
                

<div class="row" v-if="projectType == 1">
                  <div class="form-group col-md-6" >
                    <label
                      for="propositionOfValue"
                    >{{ $t('investmentOpportunity.form.propositionOfValue') }} (FR)</label>
                    <textarea
                      v-model.trim="entity.propositionOfValue.french"
                      name="propositionOfValue"
                      type="text"
                      class="form-control"
                      :data-vv-as="$t('investmentOpportunity.form.propositionOfValue')"
                      id="propositionOfValue"
                    ></textarea>
                    <span
                      class="text-danger"
                      v-show="errors.has('propositionOfValue')"
                    >{{ errors.first('propositionOfValue') }}</span>
                  </div>

                 <div class="form-group col-md-6" >
                    <label
                      for="propositionOfValueEn"
                    >{{ $t('investmentOpportunity.form.propositionOfValue') }} (EN)</label>
                    <textarea
                      v-model.trim="entity.propositionOfValue.english"
                      name="propositionOfValueEn"
                      type="text"
                      class="form-control"
                      :data-vv-as="$t('investmentOpportunity.form.propositionOfValue')"
                      id="propositionOfValueEn"
                    ></textarea>
                    <span
                      class="text-danger"
                      v-show="errors.has('propositionOfValueEn')"
                    >{{ errors.first('propositionOfValueEn') }}</span>
                  </div>
</div>


                  <div class="row">
                    <div class="form-group col-md-2" v-if="projectType == 1">
                      <label
                        for="partOfIncubationOrAccelerationProgram"
                      >{{ $t('investmentOpportunity.form.partOfIncubationOrAccelerationProgram') }}</label>
                      <input
                        type="hidden"
                        :data-vv-as="$t('investmentOpportunity.form.partOfIncubationOrAccelerationProgram')"
                        name="partOfIncubationProgram_validate"
                        v-model="entity.partOfIncubationOrAccelerationProgram"
                      />
                      <select
                        v-model="entity.partOfIncubationOrAccelerationProgram"
                        disabled
                        class="form-control"
                        id="partOfIncubationOrAccelerationProgram"
                      >
                        <option v-bind:value="false">Non</option>
                        <option v-bind:value="true">Oui</option>
                      </select>
                      <span
                        class="text-danger"
                        v-show="errors.has('partOfIncubationProgram_validate')"
                      >{{ errors.first('partOfIncubationProgram_validate') }}</span>
                    </div>

                    <div
                      class="form-group col-md-2"
                      v-if="projectType == 1 && entity.partOfIncubationOrAccelerationProgram == true"
                    >
                      <label
                        for="partOfIncubationOrAccelerationProgramSpecific"
                      >{{ $t('investmentOpportunity.form.whichOnes') }}</label>
                     <textarea
                      v-model.trim="entity.partOfIncubationOrAccelerationProgramSpecific"
                      name="partOfIncubationOrAccelerationProgramSpecific"
                      type="text"
                      class="form-control"
                      id="partOfIncubationOrAccelerationProgramSpecific"
                        v-validate="{ required: this.entity.partOfIncubationOrAccelerationProgram == true }"
                        :data-vv-as="$t('investmentOpportunity.form.partOfIncubationOrAccelerationProgram')"
                    ></textarea>
                      <span
                        class="text-danger"
                        v-show="errors.has('partOfIncubationOrAccelerationProgramSpecific')"
                      >{{ errors.first('partOfIncubationOrAccelerationProgramSpecific') }}</span>
                    </div>

                    <div class="form-group col-md-2" v-if="projectType == 1">
                      <label
                        for="projectStageInnovation"
                      >{{ $t('investmentOpportunity.form.projectStage') }}</label>
                      <input
                        type="hidden"
                        :data-vv-as="$t('investmentOpportunity.form.projectStage')"
                        name="projectStageInnovation_validate"
                        v-model="entity.projectStageInno"
                      />

                      <select
                        v-model="entity.projectStageInno"
                        disabled
                        class="form-control"
                        id="projectStageInnovation"
                        :data-vv-as="$t('investmentOpportunity.form.projectStage')"
                      >
                        <option
                          v-for="s in projectStagesInnovation"
                          :value="s.key"
                          :key="s.key"
                        >{{s.value}}</option>
                      </select>
                      <span
                        class="text-danger"
                        v-show="errors.has('projectStageInnovation_validate')"
                      >{{ errors.first('projectStageInnovation_validate') }}</span>
                    </div>

                    <div class="form-group col-md-2" v-if="projectType == 2">
                      <label
                        for="projectStageProperty"
                      >{{ $t('investmentOpportunity.form.projectStage') }}</label>
                      <input
                        type="hidden"
                        :data-vv-as="$t('investmentOpportunity.form.projectStage')"
                        name="projectStageProperty_validate"
                        v-model="entity.projectStageImmo"
                      />
                      <select
                        v-model="entity.projectStageImmo"
                        disabled
                        class="form-control"
                        id="projectStageProperty"
                        :data-vv-as="$t('investmentOpportunity.form.projectStage')"
                      >
                        <option
                          v-for="s in projectStagesProperty"
                          :value="s.key"
                          :key="s.key"
                        >{{s.value}}</option>
                      </select>
                      <span
                        class="text-danger"
                        v-show="errors.has('projectStageProperty_validate')"
                      >{{ errors.first('projectStageProperty_validate') }}</span>
                    </div>

                    <div class="form-group col-md-3" v-if="projectType == 1">
                      <label
                        for="amountNeededThisRound"
                      >{{ $t('investmentOpportunity.form.amountNeededThisRound') }}</label>
                      <input
                        v-model.lazy="entity.amoundNeededThisRound"
                        v-money="moneyConfig"
                        name="amountNeededThisRound"
                        type="text"
                        class="form-control"
                        id="amountNeededThisRound"
                        :data-vv-as="$t('investmentOpportunity.form.amountNeededThisRound')"
                      />
                      <span
                        class="text-danger"
                        v-show="errors.has('amountNeededThisRound')"
                      >{{ errors.first('amountNeededThisRound') }}</span>
                    </div>

                    <div class="form-group col-md-2">
                      <label
                        for="amountNeededFromAngesQc"
                      >{{ $t('investmentOpportunity.form.amountNeededFromAngesQc') }}</label>
                      <input
                        maxlength="100"
                        v-model.lazy="entity.amountNeededFromAngesQc"
                        v-money="moneyConfig"
                        name="amountNeededFromAngesQc"
                        type="text"
                        class="form-control"
                        id="amountNeededFromAngesQc"
                        :data-vv-as="$t('investmentOpportunity.form.amountNeededFromAngesQc')"
                      />
                      <span
                        class="text-danger"
                        v-show="errors.has('amountNeededFromAngesQc')"
                      >{{ errors.first('amountNeededFromAngesQc') }}</span>
                    </div>
 <div class="form-group col-md-2" v-if="projectType == 1">
                      <label for="startupValue">{{ $t('investmentOpportunity.form.startUpValue') }}</label>
                      <input
                        maxlength="100"
                        v-model.lazy="entity.startupValue"
                        v-money="moneyConfig"
                        name="startupValue"
                        type="text"
                        class="form-control"
                        id="startupValue"
                        :data-vv-as="$t('investmentOpportunity.form.startUpValue')"
                      />
                      <span
                        class="text-danger"
                        v-show="errors.has('startupValue')"
                      >{{ errors.first('startupValue') }}</span>
                    </div>

                  </div>
                  <div class="form-group" v-if="projectType == 1">
                    <label
                      for="investmentPurpose"
                    >{{ $t('investmentOpportunity.form.investmentPurpose') }}</label>
                    <textarea
                      v-model.trim="entity.investmentPurpose"
                      name="investmentPurpose"
                      type="text"
                      class="form-control"
                      id="investmentPurpose"
                      :data-vv-as="$t('investmentOpportunity.form.investmentPurpose')"
                    />
                    <span
                      class="text-danger"
                      v-show="errors.has('investmentPurpose')"
                    >{{ errors.first('investmentPurpose') }}</span>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">{{ $t('investmentOpportunity.form.learnMoreAboutYou') }}</div>
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-2">
                      <label for="firstName">{{ $t('investmentOpportunity.form.firstName') }}</label>
                      <input
                        maxlength="100"
                        v-model.trim="entity.firstname"
                        name="firstName"
                        type="text"
                        class="form-control"
                        id="firstName"
                        :data-vv-as="$t('investmentOpportunity.form.firstName')"
                      />
                      <span
                        class="text-danger"
                        v-show="errors.has('firstName')"
                      >{{ errors.first('firstName') }}</span>
                    </div>

                    <div class="form-group col-md-2">
                      <label for="lastName">{{ $t('investmentOpportunity.form.lastName') }}</label>
                      <input
                        maxlength="100"
                        v-model.trim="entity.lastname"
                        name="lastName"
                        type="text"
                        class="form-control"
                        id="lastName"
                        :data-vv-as="$t('investmentOpportunity.form.lastName')"
                      />
                      <span
                        class="text-danger"
                        v-show="errors.has('lastName')"
                      >{{ errors.first('lastName') }}</span>
                    </div>

                    <div class="form-group col-md-2">
                      <label for="gender">{{ $t('investmentOpportunity.form.gender') }}</label>
                      <input
                        type="hidden"
                        :data-vv-as="$t('investmentOpportunity.form.gender')"
                        name="sexes_validate"
                        v-model="entity.sex"
                      />
                      <select v-model="entity.sex" disabled class="form-control" id="gender">
                        <option v-for="s in sexes" :value="s.key" :key="s.key">{{s.value}}</option>
                      </select>
                      <span
                        class="text-danger"
                        v-show="errors.has('sexes_validate')"
                      >{{ errors.first('sexes_validate') }}</span>
                    </div>

                    <div class="form-group col-md-2">
                      <label
                        for="preferedLanguage"
                      >{{ $t('investmentOpportunity.form.preferedLanguage') }}</label>
                      <input
                        type="hidden"
                        :data-vv-as="$t('investmentOpportunity.form.preferedLanguage')"
                        name="preferedLanguage_validate"
                        v-model="entity.preferredLanguage"
                      />
                      <select
                        v-model="entity.preferredLanguage"
                        disabled
                        class="form-control"
                        id="preferedLanguage"
                      >
                        <option v-for="s in languages" :value="s.key" :key="s.key">{{s.value}}</option>
                      </select>
                      <span
                        class="text-danger"
                        v-show="errors.has('preferedLanguage_validate')"
                      >{{ errors.first('preferedLanguage_validate') }}</span>
                    </div>

                    <div class="form-group col-md-2">
                      <label for="title">{{ $t('investmentOpportunity.form.title') }}</label>
                      <input
                        maxlength="100"
                        v-model.trim="entity.title"
                        name="title"
                        type="text"
                        class="form-control"
                        id="title"
                        :data-vv-as="$t('investmentOpportunity.form.title')"
                      />
                      <span
                        class="text-danger"
                        v-show="errors.has('title')"
                      >{{ errors.first('title') }}</span>
                    </div>

                    <div class="form-group col-md-2">
                      <label for="email">{{ $t('investmentOpportunity.form.email') }}</label>
                      <input
                        maxlength="100"
                        v-model.trim="entity.email"
                        name="email"
                        type="text"
                        class="form-control"
                        id="email"
                        :data-vv-as="$t('investmentOpportunity.form.email')"
                      />
                      <span
                        class="text-danger"
                        v-show="errors.has('email')"
                      >{{ errors.first('email') }}</span>
                    </div>

                    <div class="form-group col-md-2">
                      <label for="phoneNumber">{{ $t('investmentOpportunity.form.phoneNumber') }}</label>
                      <input
                        maxlength="100"
                        v-model.trim="entity.phoneNumber"
                        v-mask="'(###) ###-####'"
                        placeholder="(999) 999-9999"
                        name="phoneNumber"
                        type="text"
                        class="form-control"
                        id="phoneNumber"
                        :data-vv-as="$t('investmentOpportunity.form.phoneNumber')"
                        v-validate="{ rules: { regex: phoneRegex() } }"
                      />
                      <span
                        class="text-danger"
                        v-if="errors.has('phoneNumber')"
                      >{{ errors.first('phoneNumber') }}</span>
                    </div>

                    <div class="form-group col-md-2">
                      <label for="heardAboutUs">{{ $t('investmentOpportunity.form.heardAboutUs') }}</label>
                      <input
                        type="hidden"
                        :data-vv-as="$t('investmentOpportunity.form.heardAboutUs')"
                        name="heardAboutUs_validate"
                        v-model="entity.heardAboutUs"
                      />
                      <select
                        v-model="entity.heardAboutUs"
                        disabled
                        class="form-control"
                        id="heardAboutUs"
                      >
                        <option v-for="s in heardAboutUs" :value="s.key" :key="s.key">{{s.value}}</option>
                      </select>
                      <span
                        class="text-danger"
                        v-if="errors.has('heardAboutUs_validate')"
                      >{{ errors.first('heardAboutUs_validate') }}</span>
                    </div>
                    <div class="form-group col-md-2" v-if="entity.heardAboutUs == 6">
                      <label
                        for="heardAboutUsSpecific"
                      >{{ $t('investmentOpportunity.form.heardAboutUsSpecific') }}</label>
                      <input
                        maxlength="100"
                        v-model.trim="entity.heardAboutUsSpecific"
                        v-validate="{ required: this.entity.heardAboutUs == 6 }"
                        :data-vv-as="$t('investmentOpportunity.form.heardAboutUsSpecific')"
                        name="heardAboutUsSpecific"
                        type="text"
                        class="form-control"
                        id="heardAboutUsSpecific"
                      />
                      <span
                        class="text-danger"
                        v-show="errors.has('heardAboutUsSpecific')"
                      >{{ errors.first('heardAboutUsSpecific') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">{{ $t('investmentOpportunity.form.intern') }}</div>
                <div class="card-body">
                  <div class="row">
                     <div class="form-group col-md-6">
                    <label
                      for="need"
                    >{{ $t('investmentOpportunity.form.need') }} (FR)</label>
                    <textarea
                      v-model.trim="entity.need.french"
                      name="need"
                      type="text"
                      class="form-control"
                      id="need"
                    ></textarea>
                  </div>
                                    <div class="form-group col-md-6">
                    <label
                      for="needEn"
                    >{{ $t('investmentOpportunity.form.need') }} (EN)</label>
                    <textarea
                      v-model.trim="entity.need.english"
                      name="needEn"
                      type="text"
                      class="form-control"
                      id="needEn"
                    ></textarea>
                  </div>
                  </div>

                  <div class="row">
                       <div class="form-group col-md-2">
                      <label
                        for="deadline"
                      >{{ $t('investmentOpportunity.form.deadline') }}</label>
                       <moment-date-picker v-model="entity.deadline"></moment-date-picker>
                    </div>
                    <div class="form-group col-md-2">
                      <label
                        for="videoLink"
                      >{{ $t('investmentOpportunity.form.videoLink') }}</label>
                        <input
                        v-model.trim="entity.videoLink"
                        name="videoLink"
                        type="text"
                        class="form-control"
                        id="videoLink"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>

           <investmentOpportunityComments
            :compMode="compMode"
            :comments="entity.comments"
          ></investmentOpportunityComments>


            <investmentOpportunityInterests
            :compMode="compMode"
            :interests="entity.interests"
          ></investmentOpportunityInterests>

          <a
            @click="editInvestmentOpportunity"
            v-if="compMode == CRUDMODE.UPDATE"
            id="editButton"
            class="btn btn-primary"
          >{{ $t('form.edit_button') }}</a>
          <a
            @click="createInvestmentOpportunity"
            v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY"
            id="addButton"
            class="btn btn-primary"
          >{{ $t('form.create_button') }}</a>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import {
  InvestmentOpportunityServiceClient,
  InvestmentOpportunityDto,
  AddressDto,
  ProjectDto,
  CompanyServiceClient,
  ProjectServiceClient,
  SectorServiceClient,
  LocalizableStringDto,
  LocalizableString,
} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import AddressComponent from '../Address.vue'
import CrudMixin from '../../shared/Mixin/CrudMixin'
import moment from 'moment'
import Enum from '../../shared/enum'
import permission from '../../shared/permission'
import Multiselect from 'vue-multiselect'
import {VueMoney} from 'v-money'
import {ToggleButton} from 'vue-js-toggle-button'
import Datepicker from 'vuejs-datepicker'
import MomentDatePicker from '../../shared/components/MomentDatePicker'
import InvestmentOpportunityComments from './InvestmentOpportunityComments'
import InvestmentOpportunityInterests from './InvestmentOpportunityInterests'

export default {
  name: 'CreateInvestmentOpportunity',
  mixins: [CrudMixin],
  directives: {VueMoney},
  inject: ['$validator'],
  data() {
    let investmentOpportunityDto = new InvestmentOpportunityDto()

    investmentOpportunityDto.init({projectType: this.projectType, comments: []})
    investmentOpportunityDto.displayInWebsite = true
    investmentOpportunityDto.need = new LocalizableStringDto()
    investmentOpportunityDto.projectDescription = new LocalizableStringDto()
    investmentOpportunityDto.propositionOfValue = new LocalizableStringDto()
    investmentOpportunityDto.headOfficeAddress = new AddressDto()
    investmentOpportunityDto.headOfficeAddress.init({})

    return {
      projects: [],
      regions: [],
      projectStagesInnovation: [],
      projectStagesProperty: [],
      founderNumbers: [],
      sexes: [],
      languages: [],
      stages: [],
      heardAboutUs: [],
      isLoading: false,
      sectors: [],
      subSectors: [],
      processStatus: [],
      entity: investmentOpportunityDto,
      moneyConfig: {
        // The character used to show the decimal place.
        decimal: '.',
        // The character used to separate numbers in groups of three.
        thousands: ',',
        // The currency name or symbol followed by a space.
        prefix: '$ ',
        // The suffix (If a suffix is used by the target currency.)
        suffix: '',
        // Level of decimal precision. REQUIRED
        precision: 0,
        // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
        masked: false,
      },
    }
  },
  computed: {
    project_validated: function() {
      if (this.entity.projectId != null) return this.entity.projectId
      else return null
    },
  },
  props: {
    projectType: 0,
  },
  methods: {
    fetchData: function() {
      let self = this

      let investmentOpportunityService = ServiceFactory.create(InvestmentOpportunityServiceClient)
      let sectorService = ServiceFactory.create(SectorServiceClient)

      let getProjectStagesInnovation = investmentOpportunityService.getProjectStagesInnovation()
      let getProjectStagesProperty = investmentOpportunityService.getProjectStagesProperty()
      let getFounderNumber = investmentOpportunityService.getFounderNumber()
      let getSexes = investmentOpportunityService.getSex()
      let getLanguages = investmentOpportunityService.getLanguage()
      let getHeardAboutUs = investmentOpportunityService.getHeardAboutUs()
      let getStages = investmentOpportunityService.getStages()
      let getSectors = sectorService.getSectors()
      let getProcessStatus = investmentOpportunityService.getProcessStatus()

      getProjectStagesInnovation
        .then(res => {
          self.projectStagesInnovation = res
        })
        .catch(err => {
          console.log(err)
        })
      getProjectStagesProperty
        .then(res => {
          self.projectStagesProperty = res
        })
        .catch(err => {
          console.log(err)
        })
      getFounderNumber
        .then(res => {
          self.founderNumbers = res
        })
        .catch(err => {
          console.log(err)
        })
      getSexes
        .then(res => {
          self.sexes = res
        })
        .catch(err => {
          console.log(err)
        })
      getLanguages
        .then(res => {
          self.languages = res
        })
        .catch(err => {
          console.log(err)
        })
      getHeardAboutUs
        .then(res => {
          self.heardAboutUs = res
        })
        .catch(err => {
          console.log(err)
        })
      getStages
        .then(res => {
          self.stages = res
        })
        .catch(err => {
          console.log(err)
        })
      getSectors
        .then(res => {
          self.sectors = res
        })
        .catch(err => {
          console.log(err)
        })
      getProcessStatus
        .then(res => {
          self.processStatus = res
        })
        .catch(err => {
          console.log(err)
        })

      if (this.compMode != Enum.Mode.CREATE) {
        let getInvestmentOpportunity = investmentOpportunityService.get(this.$route.params.id)
        getInvestmentOpportunity
          .then(res => {
            self.entity = res
            self.selectProject = res.project
            self.checkCopyMode(self.entity)

            if (res.sectorId != null) {
              let getSubSectors = sectorService.getSubSector(res.sectorId)
              getSubSectors
                .then(res => {
                  self.subSectors = res
                })
                .catch(err => {
                  console.log(err)
                })
            }
          })
          .catch(err => {
            err
          })
      }
    },
    sectorChange: function() {
      let self = this
      let sectorService = ServiceFactory.create(SectorServiceClient)
      let getSubSectors = sectorService.getSubSector(this.entity.sectorId)

      getSubSectors
        .then(res => {
          self.subSectors = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    createInvestmentOpportunity: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this

          if (result) {
            let investmentOpportunityService = ServiceFactory.create(InvestmentOpportunityServiceClient)

            investmentOpportunityService
              .create(self.manageEntity())
              .then(function(res) {})
              .then(res => {
                this.$swal('Succès', this.$i18n.t('investmentOpportunity.success.create'), 'success')
                self.redirect()
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            $('html, body')
              .stop()
              .animate({scrollTop: 0}, 1000, 'easeInOutExpo')

            self.error = this.$i18n.t('validations.formErrors')
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    editInvestmentOpportunity: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this

          if (result) {
            let investmentOpportunityService = ServiceFactory.create(InvestmentOpportunityServiceClient)

            investmentOpportunityService
              .update(self.manageEntity())
              .then(res => {
                this.$swal('Succès', this.$i18n.t('investmentOpportunity.success.edit'), 'success')
                self.redirect()
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            $('html, body')
              .stop()
              .animate({scrollTop: 0}, 1000, 'easeInOutExpo')

            self.error = this.$i18n.t('validations.formErrors')
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    redirect: function() {
      this.$router.push({name: 'investment_opportunities'})
    },
    manageEntity: function() {
      this.entity.project = null

      // Fix a wierd bug with interests, member inside insterestDto is an object instead of a MemberDto, causing a problem with the ToJSON call inside the update method.
      if (this.entity.interests) {
        for (var index = 0; index < this.entity.interests.length; index++) {
          this.entity.interests[index].member = null
        }
      }

      let cleanInvestmentOpportunity = this.cleanFields(this.entity)

      return cleanInvestmentOpportunity
    },
    asyncProjectsFind: function(search) {
      this.isLoading = true
      let self = this
      let service

      if (this.entity.projectType == 1) {
        service = ServiceFactory.create(CompanyServiceClient)
        service.getAutocomplete(1, search).then(response => {
          self.projects = response
          self.isLoading = false
        })
      } else {
        service = ServiceFactory.create(ProjectServiceClient)
        service.getAutocomplete(this.entity.projectType, 1, search).then(response => {
          self.projects = response
          self.isLoading = false
        })
      }
    },
    onRemove: function(item) {
      this.entity.projectId = null
    },
    onSelect: function(item) {
      this.entity.projectId = item.id
      this.entity.businessName = null
    },
    projectLabel: function(project) {
      return project.entreprise.name
    },
  },
  components: {
    Multiselect,
    AddressComponent: AddressComponent,
    ToggleButton,
    Datepicker,
    'moment-date-picker': MomentDatePicker,
    InvestmentOpportunityComments,
    InvestmentOpportunityInterests,
  },
}
</script>


// WEBPACK FOOTER //
// src/components/InvestmentOpportunity/CreateInvestmentOpportunity.vue